export const B2B_PROXY = "https://pcs.tangermed.ma:8001";


// WEBPACK FOOTER //
// ./src/containers/assets/config.js